module.exports = {
      id: "arrow-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "static/sprite-UPUcOAyZr3MoMAV42SXYW.svg#arrow-usage",
      toString: function () {
        return this.url;
      }
    }